// src/config/consts/path/index.ts
export const PATH = {
  HOME: '/',
  ABOUT: '/about',
  CONTACT: '/contact',
  FAQ: '/faqs',
  PARTNER: '/partners',
  SERVICES: '/services',
  SETTING: '/settings',
  NEWS: '/news',
  BLOG: '/blog',
  PROJECT: '/project',
  SUPPORT: '/support',
  CGV: '/terms-of-sale',
  TERMS: '/terms-of-service',
  COOKIEP: '/cookie-policy',
  PRIVACY: '/privacy-policy',
  LEGAL: '/legal-notice',
};
